import {Hydrate, QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {PropsWithChildren, useState} from 'react';
import {getReactQueryClientConfig} from '../util/reactQueryHelper';

interface Props {
  dehydratedState?: any;
}

export const ReactQueryProvider = ({
  children,
  dehydratedState,
}: PropsWithChildren<Props>) => {
  const [queryClient] = useState(
    () => new QueryClient(getReactQueryClientConfig())
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>{children}</Hydrate>
    </QueryClientProvider>
  );
};
